import { compact } from 'lodash'

export const checkTextContainsMoreLines = (text: string, options: { threshold: number }) => {
    const lines = text.split('\n').filter((line) => line !== '')
    return lines.length > options.threshold
}

export function joinDefinedStrings(values: (string | undefined)[], delimiter: string = ' '): string {
    return compact(values).join(delimiter)
}

export const valueOrDefault = (value: string | undefined, defaultValue = '-') => value || defaultValue
